import axios from "axios";

export default {
    bind(el, binding, vnode) {
        el.addEventListener(('ontouchstart' in document.documentElement ? "touchstart" : "click"), (e) => {
            axios.get(window.variables.tracking.clicks + '?label=' + binding.value ).then(data => {
                // Nothing to do here yet
            });
            console.log(binding.value);
            console.log(binding.arg);
        }, { passive: true });
    }
}
